import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import * as usersService from "../../services/customer.services";
import * as userMgmtService from "../../services/usermgmt.services";
import Breadcrums from "../../common/breadcrumbs";
import Loader from "../../common/loader";
import { capitalizeFirstLetter, formateDateWithMonth, formateDateWithMonthAdmin, handleServerValidations, removeSpecialCharacter } from "../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
import { Placeholder, Modal } from "rsuite";
import Swal from "sweetalert2";
import { SWAL_SETTINGS } from "../../../../utils/Constants";
import AvatarImage from "../../../user/components/AvatarImage";

const APP_UPDATE_NOTIFICATION = {
  title: "New Version Available",
  body: "A new version of The Live Shop app has been published. Please download the latest update from the App Store / Play Store to continue enjoying new features and improvements.",
};

const ViewCustomer = (props) => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const [searchParams] = useSearchParams();
  const showSendNotification = searchParams.get("notify") === "true";
  const [showdefault, setShowDefault] = useState({});
  const [sendingNotification, setSendingNotification] = useState(false);
  const [previewImage, setPreviewImage] = useState({
    open: false,
    url: "",
    title: "",
  });

  const isDefaultImage = (url) => {
    if (!url || typeof url !== "string") return true;
    return (
      url.includes("configs/default") ||
      url.includes("avatar-placeholder") ||
      url.includes("default_user") ||
      url.includes("user-default") ||
      url.includes("user-profile") ||
      url.includes("User.png") ||
      url.includes("default.png") ||
      url.trim() === ""
    );
  };

  const handleImageClick = (url, title) => {
    if (!url || isDefaultImage(url)) return;
    setPreviewImage({
      open: true,
      url,
      title: title || t("label_profile_picture") || "Profile Picture",
    });
  };

  const handleClosePreview = () => {
    setPreviewImage({
      open: false,
      url: "",
      title: "",
    });
  };
  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    {
      title: t("label_customer_details"),
      url: "/admin/customers/list/1",
    },
    { title: t("btn_view"), url: "" },
  ];

  useEffect(() => {
    console.log(params.id)
    usersService
      .Details({ _id: params.id })
      .then((response) => {
        console.log("View response-", response);
        setShowDefault(response && response.data ? response.data : []);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, [params.id]);

  const handleSendNotification = () => {
    Swal.fire({
      customClass: "swal-wide",
      title: t("msg_are_you_sure"),
      text: "Send app update notification to this user?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#403fad",
      cancelButtonColor: "#f1388b",
      confirmButtonText: t("btn_yes"),
      cancelButtonText: t("btn_cancel"),
    }).then((result) => {
      if (result.isConfirmed) {
        setSendingNotification(true);
        userMgmtService
          .SendUserNotification({
            user_id: params.id,
            title: APP_UPDATE_NOTIFICATION.title,
            body: APP_UPDATE_NOTIFICATION.body,
          })
          .then((response) => {
            if (response.success) {
              Swal.fire({
                icon: "success",
                text: response.message,
                ...SWAL_SETTINGS,
              });
            } else {
              Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((error) => {
            console.log("sendUserNotificationError", error);
            Swal.fire({
              icon: "error",
              text: "Failed to send notification",
              ...SWAL_SETTINGS,
            });
          })
          .finally(() => {
            setSendingNotification(false);
          });
      }
    });
  };

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              <div>
                <h6 className="main-content-label mb-3">
                  {t('label_customer_details')}
                </h6>
              </div>
              {showdefault && Object.keys(showdefault).length > 0 ? (
                <div className="row">
                  <div className="col-lg-12 form-group">
                    <table
                      id="simple-table"
                      className="table  table-bordered table-hover"
                    >
                      <tbody>

                        <tr>
                          <th>{t("label_profile_picture")}</th>
                          <td>
                            <div
                              style={{
                                display: "inline-block",
                                cursor: !isDefaultImage(showdefault?.profile_image) ? "pointer" : "default",
                              }}
                              onClick={() => handleImageClick(showdefault?.profile_image, t("label_profile_picture"))}
                              title={!isDefaultImage(showdefault?.profile_image) ? "Click to preview image" : ""}
                            >
                              <AvatarImage
                                src={showdefault?.profile_image}
                                name={showdefault?.name}
                                style={{
                                  width: "60px",
                                  height: "60px",
                                  borderRadius: "50%",
                                  objectFit: "cover",
                                  fontSize: "22px",
                                  border: "2px solid #e9edf4",
                                  boxShadow: "0 2px 4px rgba(0,0,0,0.08)",
                                }}
                              />
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <th>{t("label_name")}</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault.name
                              ? capitalizeFirstLetter(showdefault.name)
                              : "N/A"}
                          </td>
                        </tr>     

                        <tr>
                          <th>{t("label_email")}</th>
                          <td>
                            <div className="d-flex align-items-center gap-2">
                              <span>{showdefault && showdefault.email ? showdefault.email : "N/A"}</span>
                              {showdefault?.email ? (
                                showdefault?.is_email_verified ? (
                                  <span className="badge bg-success-transparent text-success border border-success px-2 py-1" style={{ fontSize: "11px", borderRadius: "12px" }}>
                                    <i className="ri-checkbox-circle-fill me-1"></i> Verified
                                  </span>
                                ) : (
                                  <span className="badge bg-danger-transparent text-danger border border-danger px-2 py-1" style={{ fontSize: "11px", borderRadius: "12px" }}>
                                    <i className="ri-close-circle-fill me-1"></i> Unverified
                                  </span>
                                )
                              ) : null}
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <th>{t("label_phone_number")}</th>
                          <td>
                            {showdefault && showdefault.phone_number
                              ? showdefault.phone_number
                              : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("label_registration_status")}</th>
                          <td>
                            {showdefault && showdefault.registration_status !== undefined
                              ? showdefault.registration_status.toString() === "true"
                                ? "True"
                                : "False"
                              : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("label_address")}</th>
                          <td>
                            {showdefault && showdefault.address
                              ? capitalizeFirstLetter(showdefault.address)
                              : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("list_heading_created_date")}</th>
                          <td>
                            {showdefault && showdefault.createdAt
                              ? formateDateWithMonthAdmin(showdefault.createdAt)
                              : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>Last Login IP</th>
                          <td>
                            {showdefault?.last_login_ip ? (
                              <span className="badge bg-primary-transparent text-primary" style={{ fontFamily: "monospace", fontSize: "12px", padding: "3px 8px" }}>
                                <i className="ri-computer-line me-1"></i>
                                {showdefault.last_login_ip}
                              </span>
                            ) : (
                              <span className="text-muted fst-italic">No login recorded</span>
                            )}
                          </td>
                        </tr>

                        <tr>
                          <th>Last Login Location</th>
                          <td>
                            {showdefault?.last_login_location ? (
                              <span style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
                                <i className="ri-map-pin-line text-secondary"></i>
                                <span>
                                  {typeof showdefault.last_login_location === "object"
                                    ? showdefault.last_login_location?.formatted || showdefault.last_login_location?.country || "Local / Private Network"
                                    : showdefault.last_login_location || "Local / Private Network"}
                                </span>
                              </span>
                            ) : (
                              <span className="text-muted fst-italic">No location recorded</span>
                            )}
                          </td>
                        </tr>

                        <tr>
                          <th>Last Login Date & Time</th>
                          <td>
                            {showdefault?.last_login_at ? (
                              <span>
                                <i className="ri-time-line me-1 text-primary"></i>
                                {formateDateWithMonthAdmin(showdefault.last_login_at)}
                              </span>
                            ) : (
                              <span className="text-muted fst-italic">Never logged in</span>
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    {showdefault?.login_history && showdefault.login_history.length > 0 && (
                      <div className="mt-4">
                        <h6 className="main-content-label mb-2" style={{ fontSize: "13px" }}>
                          Recent Login Activity History
                        </h6>
                        <div className="table-responsive">
                          <table className="table table-bordered table-sm text-nowrap">
                            <thead className="thead-light">
                              <tr>
                                <th>#</th>
                                <th>IP Address</th>
                                <th>Location</th>
                                <th>Device / Client</th>
                                <th>Logged In At</th>
                              </tr>
                            </thead>
                            <tbody>
                              {showdefault.login_history.slice(-5).reverse().map((entry, idx) => (
                                <tr key={idx}>
                                  <td>{idx + 1}</td>
                                  <td>
                                    <span style={{ fontFamily: "monospace" }}>{entry.ip || "N/A"}</span>
                                  </td>
                                  <td>{entry.location || "Local Network"}</td>
                                  <td>{entry.device || "Unknown"}</td>
                                  <td>{entry.logged_at ? formateDateWithMonthAdmin(entry.logged_at) : "N/A"}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              ) : (
               <Placeholder.Paragraph className="w-100" rowHeight={30} rowSpacing={5} active={true} rows={7}/>
              )}
            </div>

            <div className="mt-5 back-button d-flex align-items-center gap-2">
              <button
                className="btn ripple btn-dark"
                type="button"
                onClick={() =>
                  navigate("/admin/customers/list/1")
                }
              >
                <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                {t("btn_back")}
              </button>
              {showSendNotification && (
                <button
                  type="button"
                  className="btn btn-sm ripple btn-main-primary signbtn"
                  style={{ padding: "4px 12px", fontSize: "12px", whiteSpace: "nowrap" }}
                  onClick={handleSendNotification}
                  disabled={sendingNotification}
                >
                  {sendingNotification ? "Sending..." : "Send Notification"}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Image Preview Modal */}
      <Modal open={previewImage.open} onClose={handleClosePreview} size="md">
        <Modal.Header>
          <Modal.Title>{previewImage.title || "Image Preview"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {previewImage.url ? (
            <div className="text-center p-3">
              <img
                src={previewImage.url}
                alt={previewImage.title || "Preview"}
                style={{
                  maxWidth: "100%",
                  maxHeight: "70vh",
                  objectFit: "contain",
                  borderRadius: "8px",
                  boxShadow: "0 6px 20px rgba(0,0,0,0.15)",
                  backgroundColor: "#fff",
                }}
              />
            </div>
          ) : (
            <div className="p-4 text-muted">No image available</div>
          )}
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-between align-items-center">
          <div>
            {previewImage.url && (
              <a
                href={previewImage.url}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-sm btn-outline-primary"
              >
                <i className="fa fa-external-link mr-1"></i> Open Original
              </a>
            )}
          </div>
          <button
            type="button"
            className="btn btn-sm btn-secondary"
            onClick={handleClosePreview}
          >
            <i className="fa fa-times mr-1"></i> Close
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ViewCustomer;
